import { useState, useEffect, useRef } from "react";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete";
import QuadralForm from "@quadral/quadral-component-common/dist/components/form"
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField"
import QuadralDate from "@quadral/quadral-component-common/dist/components/date"
import { faFloppyDisk, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onlineProcessesService } from "../../services";

const UpdatePersonModal = ({open, setOpen, setLoader, showLoader, hideLoader, Loader, participation, selectedPerson, mapReferenceToOptions, quadralToast, ...props}) => {

    const [initialPersonData, setInitialPersonData] = useState({});
    const [valueBirthCity, setValueBirthCity] = useState("");
    // const [resultBirthCity, setResultBirthCity] = useState([]);
    // const [birthCityLoading, setBirthCityLoading] = useState(false);
    // const [showCityDropdown, setShowCityDropdown] = useState(false);
    const [valueBirthCountry, setValueBirthCountry] = useState("");
    // const [valueBirthCountryInsee, setValueBirthCountryInsee] = useState("");
    // const [resultBirthCountry, setResultBirthCountry] = useState([]);
    // const [birthCountryLoading, setBirthCountryLoading] = useState(false);
    // const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    
    const timeoutRef = useRef(null);

    const [personFormData, setPersonFormData] = useState({
            situationChangeReason: '',
            departureDate: '',
            deceaseDate: '',
            householdRelation: '',
            taxDeclarant: '',
            civility: '',
            firstname: '',
            lastname: '',
            birtCountry: '',
            birthCity: '',
            nationalityPerCategory: '',
            taxDependent: '',
            taxDependentApartFromHome: '',
            custodyRights: '',
            visitationRights: '',
            householdLink: '',
            disabilityStatus: '',
            familySituation: '',
            familySituationDate: ''
        });

    const yesNoOptions = [
        {
            code: "",
            label: ""
        },
        {
            code: "true",
            label: "Oui"
        },
        {
            code: "false",
            label: "Non"
        },
    ]

    useEffect(() => {
        if (selectedPerson && open) {
            const initialData = {
                situationChangeReason: selectedPerson?.situationChangeReason || '',
                departureDate: selectedPerson?.departureDate || '',
                deceaseDate: selectedPerson?.deceaseDate || '',
                // numberOfTaxShares: selectedPerson?.numberOfTaxShares || '',
                householdRelation: selectedPerson?.householdRelation || '',
                taxDeclarant: selectedPerson?.taxDeclarant || '',
                civility: selectedPerson?.civility || '',
                firstname: selectedPerson?.firstname || '',
                lastname: selectedPerson?.lastname || '',
                maidenName: selectedPerson?.maidenName || '',
                birthCountry: selectedPerson?.birthCountry || '',
                birthCity: selectedPerson?.birthCity || '',
                nationalityPerCategory: selectedPerson?.nationalityPerCategory || '',
                taxDependent: selectedPerson?.taxDependent || '',
                taxDependentApartFromHome: selectedPerson?.taxDependentApartFromHome || '',
                custodyRights: selectedPerson?.custodyRights || '',
                visitationRights: selectedPerson?.visitationRights || '',
                householdLink: selectedPerson?.householdLink || '',
                disabilityStatus: selectedPerson?.disabilityStatus || '',
                familySituation: selectedPerson?.familySituation || '',
                familySituationDate: selectedPerson?.familySituationDate || ''
            };

            setInitialPersonData(initialData);
            setPersonFormData(initialData);
            setValueBirthCountry(selectedPerson?.birthCountry || '');
            setValueBirthCity(selectedPerson?.birthCity || '');
        }
    }, [selectedPerson, open]);

    // function birthCityAutocomplete(city) {
    //     if (!city || city.trim().length < 2) {
    //         setResultBirthCity([]);
    //         setShowCityDropdown(false);
    //         return;
    //     }

    //     setBirthCityLoading(true);

    //     onlineProcessesService.findCity(city)
    //         .then(data => {
    //             setResultBirthCity(Array.isArray(data) ? data : []);
    //             setShowCityDropdown(Array.isArray(data) && data.length > 0);
    //         })
    //         .catch(err => {
    //             console.error(err);
    //             setResultBirthCity([]);
    //             setShowCityDropdown(false);
    //         })
    //         .finally(() => {
    //             setBirthCityLoading(false);
    //         });
    // }

    function birthCountryAutocomplete(country) {
        if (!country || country.trim().length < 2) {
            // setResultBirthCountry([]);
            // setShowCountryDropdown(false);
            return;
        }

        // setBirthCountryLoading(true);
        onlineProcessesService.findCountry(country)
            .then(data => {
                // setResultBirthCountry(Array.isArray(data) ? data : []);
                // setShowCountryDropdown(Array.isArray(data) && data.length > 0);
            })
            .catch(err => {
                console.error(err);
                // setResultBirthCountry([]);
                // setShowCountryDropdown(false);
            })
            .finally(() => {
                // setBirthCountryLoading(false);
            });
    }

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (valueBirthCountry && valueBirthCountry.length > 1) {
            timeoutRef.current = setTimeout(() => {
                birthCountryAutocomplete(valueBirthCountry);
            }, 300);
        } else {
            // setResultBirthCountry([]);
            // setShowCountryDropdown(false);
        }

        handleField('birthCountry', valueBirthCountry);
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [valueBirthCountry]);

    
    function handleClose() {
        setOpen(false);
    };

        function addEmptyOption(options) {
        if (!options || options.length === 0) {
            return [{ code: "", label: "" }];
        }
        const hasEmptyOption = options.some(opt => opt.code === "" || opt.code === null);
        if (hasEmptyOption) {
            return options;
        }
        return [{ code: "", label: "" }, ...options];
    };

    function handleField(fieldName, value) {
        setPersonFormData(formData => ({
            ...formData,
            [fieldName]: value?.code || value,
        }))
    }

    function getOptions(ref) {
        if (typeof ref === 'string') {
            const options = mapReferenceToOptions(ref);
            return addEmptyOption(options);
        } else {
            return (ref)
        }
    }

    function getValue(value, ref){
        const result = getOptions(ref);
        const dataTable = Array.isArray(result) && result.length ? result : ref;
        return (
            dataTable.find(
                option => option.code === value
            ) ?? null
        )
    };

    function createJsonPatch() {
        const patches = [];

        Object.keys(personFormData).forEach(key => {
            const currentValue = personFormData[key];
            const initialValue = initialPersonData[key];
            const specialKeysMap = {
                birthCity: valueBirthCity, //valueBirthCityInsee
                birthCountry: valueBirthCountry // valueBirthCountryInsee
            };
            
            if (currentValue !== initialValue) {
                if(specialKeysMap[key]?.id && (specialKeysMap[key].name === currentValue || specialKeysMap[key].id === currentValue)){
                    patches.push({
                        op: "replace",
                        path: `${key}Insee`,
                        value: specialKeysMap[key].id || ''
                    });
                }else{
                    patches.push({
                        op: "replace",
                        path: `${key}`,
                        value: currentValue || ''
                    });
                }
            }
        });

        return patches;
    }

    function formCheck() {
    const hasAnyValue = personFormData.situationChangeReason || 
                        personFormData.departureDate || 
                        personFormData.deathDate;
    if (!hasAnyValue) {
        return true;
    }
    if (personFormData.situationChangeReason && !personFormData.departureDate) {
        quadralToast.error("Veuillez renseigner la date de départ");
        return false;
    }

    if (personFormData.departureDate && !personFormData.situationChangeReason) {
        quadralToast.error("Veuillez sélectionner un motif de changement de situation");
        return false;
    }

    if ((personFormData.situationChangeReason === "deces" || 
         personFormData.situationChangeReason?.code === "deces")) {
        if (!personFormData.deathDate) {
            quadralToast.error("Veuillez renseigner la date de décès");
            return false;
        }
        if (!personFormData.departureDate) {
            quadralToast.error("Veuillez renseigner la date de départ");
            return false;
        }
    }

    if (personFormData.deathDate) {
        if (!personFormData.situationChangeReason) {
            quadralToast.error("Veuillez sélectionner le motif 'Décès'");
            return false;
        }
        if (personFormData.situationChangeReason !== "deces" && 
            personFormData.situationChangeReason?.code !== "deces") {
            quadralToast.error("Si vous indiquez une date de décès, le motif doit être 'Décès'");
            return false;
        }
        if (!personFormData.departureDate) {
            quadralToast.error("Veuillez renseigner la date de départ");
            return false;
        }
    }

    return true;
}

    async function handleConfirm() {
        if (!selectedPerson) return;

        if(!formCheck()) return;

        const jsonPatch = createJsonPatch();

        if (jsonPatch.length === 0) {
            setOpen(false);
            return;
        }

        showLoader();
        setLoader && setLoader(true);

        try {
            await onlineProcessesService.patchPersonRecord(
                participation.id,
                selectedPerson.id,
                jsonPatch
            );

            if (props.refreshPersonsData) {
                await props.refreshPersonsData();
            }

            quadralToast.success("Fiche personne mise à jour avec succès");
            setOpen(false);

        } catch (error) {
            console.error("Erreur lors de la mise à jour de la personne : ", error);
            quadralToast.error("Erreur lors de la mise à jour de la personne");
        } finally {
            hideLoader();
            setLoader && setLoader(false);
        }
    }
    
    return(
        <QuadralModal
            size='XL'
            title='Modifier le membre du foyer'
            subtitle={selectedPerson?.personRecordName}
            icon={<FontAwesomeIcon icon={faUserPen}/>}
            open={open}
            setOpen={setOpen}
            noButton
            action={
                <>
                    <QuadralButton size="medium" color="secondary"
                                    onClick={() => handleClose()}>
                        Annuler
                    </QuadralButton>
                    <QuadralButton size="medium" startIcon={<FontAwesomeIcon icon={faFloppyDisk}/>}
                                    onClick={() => handleConfirm()}>
                        Enregistrer
                    </QuadralButton>
                </>
            }
        >

            <QuadralForm>
                <QuadralAutocomplete 
                    id="situationChangeReason" 
                    label='Motif de départ'
                    value={getValue(personFormData.situationChangeReason, "PERSON_RECORD_SITUATION_CHANGE_REASON_IMPORT")}
                    options={getOptions("PERSON_RECORD_SITUATION_CHANGE_REASON_IMPORT")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('situationChangeReason', value)}
                    required={(
                        personFormData.situationChangeReason !== '' && personFormData.situationChangeReason !== null) ||
                        personFormData.departureDate || 
                        personFormData.deathDate}
                />
                <QuadralDate 
                    id='departureDate'
                    label="Date de départ"
                    value={personFormData.departureDate}
                    onChange={(date) => handleField('departureDate', date?.format('YYYY-MM-DD'))}
                    required={
                        (personFormData.departureDate !== '' && personFormData.departureDate !== null) ||
                        personFormData.situationChangeReason || 
                        personFormData.deathDate}
                />
                <QuadralDate 
                    id='deceaseDate'
                    label="Date de décès"
                    value={personFormData.deathDate}
                    onChange={(date) => handleField('deathDate', date?.format('YYYY-MM-DD'))}
                    required={
                        (personFormData.deathDate !== '' && personFormData.deathDate !== null) ||
                        personFormData.situationChangeReason === "deces" ||
                        personFormData.situationChangeReason?.code === "deces"}
                />
                <QuadralAutocomplete 
                    id="taxDeclarant" 
                    label='Déclarant fiscal principal'
                    value={getValue(personFormData.taxDeclarant, yesNoOptions)}
                    options={yesNoOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDeclarant', value)}
                />
                {personFormData?.taxDeclarant !== "true" && (
                    <QuadralAutocomplete 
                        id="householdRelation" 
                        label='Parent fiscal'
                        value={getValue(personFormData.householdRelation, "PERSON_RECORD_HOUSE_HOLD_LINK")}
                        options={getOptions("PERSON_RECORD_HOUSE_HOLD_LINK")}
                        getOptionLabel={(option) => option.label}
                        onChange={(e, value) => handleField('householdRelation', value)}
                    />
                )}
                <QuadralAutocomplete 
                    id="civility" 
                    label='Civilité'
                    value={getValue(personFormData.civility, "PERSON_RECORD_TITLE")}
                    options={getOptions("PERSON_RECORD_TITLE")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('civility', value)}
                />
                <QuadralTextField 
                    id="firstname" 
                    label='Prénom'
                    value={personFormData.firstname}
                    onChange={(value) => {handleField('firstname', value)}}
                />
                <QuadralTextField 
                    id="lastname" 
                    label='Nom'
                    value={personFormData.lastname}
                    onChange={(value) => {handleField('lastname', value)}}
                />
                <QuadralTextField 
                    id="maidenName" 
                    label='Nom de naissance'
                    value={personFormData.maidenName}
                    onChange={(value) => {handleField('maidenName', value)}}
                />
                <QuadralAutocomplete 
                    id="nationalityPerCategory" 
                    label='Nationalité'
                    value={getValue(personFormData.nationalityPerCategory, "PERSON_RECORD_NATIONALITY_PER_CATEGORY")}
                    options={getOptions("PERSON_RECORD_NATIONALITY_PER_CATEGORY")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('nationalityPerCategory', value)}
                />
                <QuadralTextField
                    id="birthCountry" 
                    label='Pays de naissance'
                    // value={personFormDatvalueBirthCountry}
                    // onChange={(value) => handleField('birthCountry', value)}
                    value={valueBirthCountry}
                    onChange={value => {setValueBirthCountry(value)}}
                    // onFocus={() => {
                        // if (resultBirthCountry.length > 0) {
                            // setShowCountryDropdown(true);
                        // }
                    // }}
                    // placeholder="Tapez pour rechercher..."
                />
                <QuadralTextField
                    id="birthCity" 
                    label='Ville de naissance'
                    value={personFormData.birthCity}
                    onChange={(value) => handleField('birthCity', value)}
                    // onFocus={() => {
                        // if (resultBirthCountry.length > 0) {
                            // setShowCountryDropdown(true);
                        // }
                    // }}
                    // placeholder="Tapez pour rechercher..."
                />
                {/* <QuadralAutocomplete
                    id="birthCity" 
                    label='Ville de naissance'
                    value={getValue(personFormData.birthCity, resultBirthCity)}
                    options={resultBirthCity}
                    loading={birthCityLoading}
                    getOptionLabel={(option) => option.name || option.label}
                    onInputChange={(event, value) => {
                        console.log(value);
                        birthCityAutocomplete(value);
                    }}
                    onChange={(e, value) => handleField('birthCity', value)}
                />
                <QuadralAutocomplete
                    id="birthCountry" 
                    label='Pays de naissance'
                    value={getValue(personFormData.birthCountry, resultBirthCountry)}
                    options={resultBirthCountry}
                    loading={birthCountryLoading}
                    getOptionLabel={(option) => option.name || option.label}
                    onInputChange={(event, value) => {
                        console.log(value);
                        birthCountryAutocomplete(value);
                    }}
                    onChange={(e, value) => handleField('birthCountry', value)}
                /> */}
                <QuadralAutocomplete 
                    id="familySituation" 
                    label='État matrimonial'
                    value={getValue(personFormData.familySituation, "PERSON_RECORD_FAMILY_SITUATION")}
                    options={getOptions("PERSON_RECORD_FAMILY_SITUATION")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('familySituation', value)}
                />
                <QuadralDate 
                    id='familySituationDate'
                    label="Date de changement"
                    value={personFormData.familySituationDate}
                    onChange={(date) => handleField('familySituationDate', date?.format('YYYY-MM-DD'))}
                />
                <QuadralAutocomplete 
                    id="taxDependent" 
                    label="À charge"
                    value={getValue(personFormData.taxDependent, "PERSON_RECORD_TAX_DEPENDENT")}
                    options={getOptions("PERSON_RECORD_TAX_DEPENDENT")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDependent', value)}
                />
                <QuadralAutocomplete 
                    id="taxDependentApartFromHome" 
                    label="À charge personne hors foyer"
                    value={getValue(personFormData.taxDependentApartFromHome, "PERSON_RECORD_TAX_DEPENDENT_APART_FROM_HOME")}
                    options={getOptions("PERSON_RECORD_TAX_DEPENDENT_APART_FROM_HOME")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDependentApartFromHome', value)}
                />
                <QuadralAutocomplete 
                    id="visitationRights" 
                    label="Droit de visite"
                    value={getValue(personFormData.visitationRights, "PERSON_RECORD_VISITATION_RIGHTS")}
                    options={getOptions("PERSON_RECORD_VISITATION_RIGHTS")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('visitationRights', value)}
                />
                <QuadralAutocomplete 
                    id="householdLink" 
                    label="Lien de parenté"
                    value={getValue(personFormData.householdLink, "PERSON_RECORD_HOUSE_HOLD_LINK")}
                    options={getOptions("PERSON_RECORD_HOUSE_HOLD_LINK")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('householdLink', value)}
                />
                <QuadralAutocomplete 
                    id="disabilityStatus" 
                    label="Situation de handicap"
                    value={getValue(personFormData.disabilityStatus, "PERSON_RECORD_DISABILITY_STATUS")}
                    options={getOptions("PERSON_RECORD_DISABILITY_STATUS")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('disabilityStatus', value)}
                />
            </QuadralForm>
        </QuadralModal>
    )
}

export default UpdatePersonModal;